import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { InputNumber } from "primereact/inputnumber";

import {
    addProcessing,
    updateProcessing,
    setDataNull,
} from "../../store/processings/slice";
import { Dropdown } from "primereact/dropdown";
import "../../assets/scss/theme-base/ModalAddDashbord.css";
import { getDataAll } from "../../store/materials/slice";
import { Calendar } from "primereact/calendar";
import { getOrder } from "../../store/order/slice";
import { Checkbox } from "primereact/checkbox";

const ModalAddProcessings = ({ visible, onHide, toast, rowData }) => {
    const dispatch = useDispatch();
    const [isFinished, setIsFinished] = useState(false);
    const { errorInsert, insertData, updateData, errorUpdate, materialData } =
        useSelector(
            (state) => ({
                errorInsert: state.Processings.errorInsert,
                insertData: state.Processings.insertData,
                updateData: state.Processings.updateData,
                errorUpdate: state.Processings.errorUpdate,
                materialData: state.Materials.materialData,
            }),
            shallowEqual
        );

    useEffect(() => {
        dispatch(getDataAll({ page: 1, limit: 100 }));
    }, []);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            code: rowData?.code || "",
            name: rowData?.name || "",
            price: rowData?.price || 0,
            quantity: rowData?.quantity || 0,
            unit: rowData?.unit || "",
            hh: rowData?.hh || "",
            classificationId: rowData?.classificationId || "",
            materialId: rowData?.materialId || "",
            type: rowData?.type || "",
            expectedArrivalDate: rowData?.expectedArrivalDate
                ? new Date(rowData.expectedArrivalDate)
                : null,
            processingRequestNumber: rowData?.processingRequestNumber || "",
            productId: rowData?.productId || "",
            description: rowData?.description || "",
            po: rowData?.po || "",
            supplier: rowData?.supplier || "",
            calculationMethod: rowData?.calculationMethod || "",
            proposedBy: rowData?.proposedBy || "",
            requestSentDate: rowData?.requestSentDate
                ? new Date(rowData.requestSentDate)
                : null,
            expectedReceiveDate: rowData?.expectedReceiveDate
                ? new Date(rowData.expectedReceiveDate)
                : null,
            purchasing: rowData?.purchasing || "",
            isFinished: rowData?.isFinished || false,
        },

        onSubmit: async (value) => {
            const data = {
                ...value,
                ...(rowData?.id ? { id: rowData.id } : {}),
            };

            if (rowData?.id) {
                dispatch(updateProcessing({ data }));
            } else {
                dispatch(addProcessing({ data }));
            }
        },
    });

    useEffect(() => {
        if (errorInsert) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorInsert?.response?.data?.message,
                life: 3000,
            });
            dispatch(setDataNull());
        }
        if (insertData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Thêm gia công thành công",
                life: 3000,
            });
            formik.resetForm();
            dispatch(setDataNull());
            onHide();
        }
    }, [errorInsert, insertData]);
    useEffect(() => {
        if (errorUpdate) {
            toast.current?.show({
                severity: "error",
                summary: "Thất bại",
                detail: errorUpdate?.response?.data?.message,
                life: 3000,
            });
            dispatch(setDataNull());
        }
        if (updateData) {
            toast.current?.show({
                severity: "success",
                summary: "Thành công",
                detail: "Cập gia công tư thành công",
                life: 3000,
            });
            formik.resetForm();
            dispatch(setDataNull());
            onHide();
        }
    }, [errorUpdate, updateData]);

    return (
        <Dialog
            visible={visible}
            onHide={() => {
                formik.resetForm();
                onHide();
            }}
            header="Gia công"
            modal
            style={{ height: "84%", width: "40%" }}
            className="responsive-dialog"
            footer={
                <div>
                    <Button
                        label="Hủy"
                        onClick={() => {
                            formik.resetForm();
                            onHide();
                        }}
                        severity="secondary"
                        className="p-button-text"
                    />
                    <Button
                        type="submit"
                        label="Lưu"
                        onClick={() => {
                            console.log("Save button clicked");
                            formik.handleSubmit();
                        }}
                    />
                </div>
            }
        >
            <div className="bg-white p-3 border-round-md">
                <div className="flex flex-column mb-4 gap-3">
                    <div className="flex justify-content-between align-items-center col-12 gap-5">
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Mã vật tư</label>
                            <Dropdown
                                id="materialId"
                                name="materialId"
                                value={formik.values.materialId}
                                options={
                                    Array.isArray(materialData?.data?.items)
                                        ? materialData.data.items.map(
                                              (item) => ({
                                                  label: item.name,
                                                  value: item.id,
                                              })
                                          )
                                        : []
                                }
                                filter
                                onChange={(e) =>
                                    formik.setFieldValue("materialId", e.value)
                                }
                                style={{
                                    height: "40px",
                                    width: "100%",
                                    marginTop: "5px",
                                }}
                                className={`responsive-input ${
                                    !formik.touched.materialId ||
                                    !formik.errors.materialId
                                        ? "border-300"
                                        : "border-red-500"
                                }`}
                            />
                            {formik.touched.materialId &&
                            formik.errors.materialId ? (
                                <div style={{ color: "red" }}>
                                    {formik.errors.materialId.toString()}
                                </div>
                            ) : null}
                        </div>
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Po</label>
                            <InputText
                                id="po"
                                name="po"
                                value={formik.values.po}
                                onChange={formik.handleChange}
                                style={{ height: "40px" }}
                                className={
                                    formik.touched.po && formik.errors.po
                                        ? "p-invalid"
                                        : ""
                                }
                            />
                            {formik.touched.po && formik.errors.po ? (
                                <div style={{ color: "red" }}>
                                    {formik.errors.po.toString()}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-center col-12 gap-5">
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Nhà cung cấp</label>
                            <InputText
                                id="supplier"
                                name="supplier"
                                value={formik.values.supplier}
                                onChange={formik.handleChange}
                                style={{ height: "40px" }}
                                className={
                                    formik.touched.supplier &&
                                    formik.errors.supplier
                                        ? "p-invalid"
                                        : ""
                                }
                            />
                            {formik.touched.supplier &&
                            formik.errors.supplier ? (
                                <div style={{ color: "red" }}>
                                    {formik.errors.supplier.toString()}
                                </div>
                            ) : null}
                        </div>
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Quy cách tính</label>
                            <InputText
                                id="calculationMethod"
                                name="calculationMethod"
                                value={formik.values.calculationMethod}
                                onChange={formik.handleChange}
                                style={{ height: "40px" }}
                                className={
                                    formik.touched.calculationMethod &&
                                    formik.errors.calculationMethod
                                        ? "p-invalid"
                                        : ""
                                }
                            />
                            {formik.touched.calculationMethod &&
                            formik.errors.calculationMethod ? (
                                <div style={{ color: "red" }}>
                                    {formik.errors.calculationMethod.toString()}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-center col-12 gap-5">
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Số lượng</label>
                            <InputNumber
                                id="quantity"
                                name="quantity"
                                value={formik.values.quantity}
                                onValueChange={(e) =>
                                    formik.setFieldValue("quantity", e.value)
                                }
                                mode="decimal"
                                min={0}
                                style={{ height: "40px", width: "100%" }}
                                className={
                                    formik.touched.quantity &&
                                    formik.errors.quantity
                                        ? "p-invalid"
                                        : ""
                                }
                            />
                            {formik.touched.quantity &&
                                formik.errors.quantity && (
                                    <div style={{ color: "red" }}>
                                        {formik.errors.quantity}
                                    </div>
                                )}
                        </div>
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Người ĐX</label>
                            <InputText
                                id="proposedBy"
                                name="proposedBy"
                                value={formik.values.proposedBy}
                                onChange={formik.handleChange}
                                className={`responsive-input ${
                                    formik.touched.proposedBy &&
                                    formik.errors.proposedBy
                                        ? "p-invalid"
                                        : ""
                                }`}
                                style={{ height: "40px" }}
                            />
                            {formik.touched.proposedBy &&
                            formik.errors.proposedBy ? (
                                <div style={{ color: "red" }}>
                                    {formik.errors.proposedBy.toString()}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="flex justify-content-between align-items-center col-12 gap-5">
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Ngày gửi YCVT</label>
                            <Calendar
                                id="requestSentDate"
                                name="requestSentDate"
                                value={formik.values.requestSentDate}
                                onChange={(e) =>
                                    formik.setFieldValue(
                                        "requestSentDate",
                                        e.value
                                    )
                                }
                                dateFormat="dd/mm/yy"
                                showIcon
                                style={{ height: "40px", width: "100%" }}
                            />
                        </div>
                        <div className="flex flex-column w-6">
                            <label className="mb-2">
                                Ngày YC có hàng theo YCVT
                            </label>
                            <Calendar
                                id="expectedReceiveDate"
                                name="expectedReceiveDate"
                                value={formik.values.expectedReceiveDate}
                                onChange={(e) =>
                                    formik.setFieldValue(
                                        "expectedReceiveDate",
                                        e.value
                                    )
                                }
                                dateFormat="dd/mm/yy"
                                showIcon
                                style={{ height: "40px", width: "100%" }}
                            />
                        </div>
                    </div>

                    <div className="flex justify-content-between align-items-center col-12 gap-5">
                        <div className="flex flex-column w-6">
                            <label className="mb-2">PC mua hàng</label>
                            <InputText
                                id="purchasing"
                                name="purchasing"
                                value={formik.values.purchasing}
                                onChange={formik.handleChange}
                                className={`responsive-input ${
                                    formik.touched.purchasing &&
                                    formik.errors.purchasing
                                        ? "p-invalid"
                                        : ""
                                }`}
                                style={{ height: "40px" }}
                            />
                            {formik.touched.purchasing &&
                            formik.errors.purchasing ? (
                                <div style={{ color: "red" }}>
                                    {formik.errors.purchasing.toString()}
                                </div>
                            ) : null}
                        </div>
                        <div className="flex flex-column w-6">
                            <label className="mb-2">Ghi chú</label>
                            <InputText
                                id="description"
                                name="description"
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                style={{ height: "40px" }}
                            />
                        </div>
                    </div>
                    <div className="flex align-items-center">
                        <Checkbox
                            inputId="isFinished"
                            name="isFinished"
                            onChange={(e) =>
                                formik.setFieldValue("isFinished", e.checked)
                            }
                            checked={formik.values.isFinished}
                        />
                        <label htmlFor="isFinished" className="ml-2">
                            Hoàn thành
                        </label>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default ModalAddProcessings;
